import React from "react";
import { DropzoneDialog } from "material-ui-dropzone";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

class MediaFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { files: [], open: false };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.files) {
      if (nextProps.files.length === 0) {
        this.setState({ files: nextProps.files });
      }
    }
  }

  handleChange(files) {
    this.setState({
      files: files
    });
    this.props.onChange(files, this.props.meta_data);
  }

  render() {
    return (
      <React.Fragment>
        {this.props.noRow ? (
          <Button
            variant={this.state.files.length > 0 ? "contained" : "outlined"}
            color="primary"
            onClick={() => this.setState({ open: true })}
            style={{
              fontSize: "0.75rem",
              paddingTop: "4px",
              paddingRight: "12px"
            }}
            startIcon={
              this.state.files.length > 0 ? (
                <CheckCircleIcon />
              ) : (
                <CloudUploadIcon />
              )
            }
          >
            {this.props.title}
          </Button>
        ) : (
          <div>
            <div style={{ width: this.props.width, height: this.props.height }}>
              <Button
                variant={this.state.files.length > 0 ? "contained" : "outlined"}
                color="primary"
                onClick={() => this.setState({ open: true })}
                style={{
                  fontSize: "0.75rem",
                  paddingTop: "4px",
                  paddingRight: "12px"
                }}
                startIcon={
                  this.state.files.length > 0 ? (
                    <CheckCircleIcon />
                  ) : (
                    <CloudUploadIcon />
                  )
                }
              >
                {this.props.title}
              </Button>
            </div>
          </div>
        )}
        <DropzoneDialog
          cancelButtonText={"Cancelar"}
          submitButtonText={"Adjuntar"}
          dropzoneText="Arrastra los archivos aquí o buscalos. Solo podrán ser pdf"
          dialogTitle="Adjuntar archivos"
          maxFileSize={5000000}
          filesLimit={10}
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          onSave={files => {
            this.handleChange(files);
            this.setState({ open: false });
          }}
          showPreviews={true}
          showFileNamesInPreview={true}
          acceptedFiles={
            this.props.acceptedFiles ? this.props.acceptedFiles : []
          }
        />
      </React.Fragment>
    );
  }
}

export default MediaFile;
